import PopupInvitation from "./popups/PopupInvitation";
import PopupAreYouSure from "./popups/PopupAreYouSure";

export const popups: {[key: string]: any} = {
  invitation: PopupInvitation,
  areYouSure: PopupAreYouSure
};
